import { render, staticRenderFns } from "./CourseClassification.vue?vue&type=template&id=cee7b274&scoped=true&"
import script from "./course-classification.js?vue&type=script&lang=js&"
export * from "./course-classification.js?vue&type=script&lang=js&"
import style0 from "./CourseClassification.vue?vue&type=style&index=0&id=cee7b274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee7b274",
  null
  
)

export default component.exports